import { createAction, props } from '@ngrx/store';

import { UserSearchParams } from '.';

export namespace UsersActions {
  export enum Type {
    LIST_USERS_SEARCH_RESULT = '[USERS] List Users Search Result',
    LIST_USERS_SEARCH_RESULT_SUCCESS = '[USERS] List Users Search Result Success',
    LIST_USERS_SEARCH_RESULT_ERROR = '[USERS] List Users Search Result Error',
    LIST_COMPANY_USERS_SEARCH_RESULT = '[COMPANY USERS] List Users Search Result',
    LIST_COMPANY_USERS_SEARCH_RESULT_SUCCESS = '[COMPANY USERS] List Users Search Result Success',
    LIST_COMPANY_USERS_SEARCH_RESULT_ERROR = '[COMPANY USERS] List Users Search Result Error',
    LIST_USERS_SEARCH_FETCH_MORE = '[USERS] List Users fetch more search results',
    LIST_USERS_SEARCH_FETCH_MORE_SUCCESS = '[USERS] List Users fetch more search results Success',
    LIST_USERS_SEARCH_FETCH_MORE_ERROR = '[USERS] List Users fetch more search results Error',
  }

  // Search result
  export const listUsersSearchResult = createAction(
    Type.LIST_USERS_SEARCH_RESULT,
    props<{ searchParams: UserSearchParams }>()
  );

  export const listUsersSearchResultSuccess = createAction(
    Type.LIST_USERS_SEARCH_RESULT_SUCCESS,
    props<{ payload: any }>()
  );

  export const listUsersSearchResultError = createAction(Type.LIST_USERS_SEARCH_RESULT_ERROR);

  // Company users search result
  export const listCompanyUsersSearchResult = createAction(
    Type.LIST_COMPANY_USERS_SEARCH_RESULT,
    props<{
      companyNumber: string;
    }>()
  );

  export const listCompanyUsersSearchResultSuccess = createAction(
    Type.LIST_COMPANY_USERS_SEARCH_RESULT_SUCCESS,
    props<{ payload: any }>()
  );

  export const listCompanyUsersSearchResultError = createAction(
    Type.LIST_COMPANY_USERS_SEARCH_RESULT_ERROR
  );

  // fetch more user search results
  export const listUsersSearchFetchMore = createAction(
    Type.LIST_USERS_SEARCH_FETCH_MORE,
    props<{ searchParams: UserSearchParams }>()
  );

  export const listUsersSearchFetchMoreSuccess = createAction(
    Type.LIST_USERS_SEARCH_FETCH_MORE_SUCCESS,
    props<{ payload: any }>()
  );

  export const listUsersSearchFetchMoreError = createAction(
    Type.LIST_USERS_SEARCH_FETCH_MORE_ERROR
  );
}
